export default __webpack_public_path__ + "static/blur3-a75c6d05f8a72b100cee646f2526428c.png";